import React from 'react';
import ApartmentBox from '../apartmentBox';
import ApartmentBoxLoader from '../apartmentBox/apartmentBoxLoader';
import {
	Container, Columns,
	H2
} from '../base';
import * as StyledApartmentShowcase from './apartmentShowcase.styles';
import ApartmentsListError from '../apartmentsList/apartmentsListError';

const ApartmentShowcase = ({
	title = '',
	apartments = [],
	error = false,
	loading = false,
	useAnimation = false,
	maxApts = 0,
}) => {
	return (
		<StyledApartmentShowcase.Wrapper>
			<Container>
				<H2 marginBottom>{title}</H2>
				{
					error && (
						<StyledApartmentShowcase.ErrorWrapper>
							<ApartmentsListError />
						</StyledApartmentShowcase.ErrorWrapper>
					)
				}
				<Columns>
					{
						loading && !error && [...Array(3)].map((value, index) => (
							<StyledApartmentShowcase.AnimatedColumn
								tablet={1 / 2}
								desktopSmall={1 / 3}
								desktopLarge={1 / 3}
								useAnimation={useAnimation}
								key={index}>
								<ApartmentBoxLoader />
							</StyledApartmentShowcase.AnimatedColumn>
						))
					}
					{
						!loading && !error && apartments && (maxApts ? apartments.slice(0, maxApts) : apartments).map((apartment, index) => apartment && (
							<StyledApartmentShowcase.AnimatedColumn
								tablet={1 / 2}
								desktopSmall={1 / 3}
								desktopLarge={1 / 3}
								useAnimation={useAnimation}
								key={`${index}-${apartment.Id}`}>
								<ApartmentBox apartment={apartment} />
							</StyledApartmentShowcase.AnimatedColumn>
						))
					}
				</Columns>
			</Container>
		</StyledApartmentShowcase.Wrapper>
	);
};

export default ApartmentShowcase;
